// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsSkuNumberStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
    wrapper?: TypographyProps;
}

export const skuNumberStyles: ProductDetailsSkuNumberStyles = {};

const styles = skuNumberStyles;

const ProductDetailsSkuNumber: React.FC<Props> = ({ product }) => {
    if (!product.detail?.sku) {
        return null;
    }

    return (
        <Typography {...styles.wrapper}>
            <Typography {...styles.labelText}>{translate("SKU")}</Typography>
            <Typography {...styles.valueText} data-test-selector="sku">
                {product.detail.sku}
            </Typography>
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsSkuNumber),
    definition: {
        displayName: "SKU Number",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
